import { FETCH_SETTINGS_REQUEST_ASYNC as FETCH_GROUP_SETTINGS_REQUEST_ASYNC } from 'containers/GroupSettings/Wizard/constants'
import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  INCIDENT_RESPONSE_REQUEST_ASYNC,
  SUBMIT_INCIDENT_RESPONSE_ASYNC,
  UPDATE_DEEP_SETTINGS_FIELD,
  UPDATE_SETTINGS_FIELD,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_DEEP_SETTINGS_FIELD:
        return {
          ...state,
          data: {
            ...state.data,
            [action.payload.field]: state.data[action.payload.field].map((elem) => {
              if (elem.localeId === action.payload.id) {
                elem.text = action.payload.value
              }
              return elem
            }),
          },
        }
      case UPDATE_SETTINGS_FIELD:
        return {
          ...state,
          data: {
            ...state.data,
            [action.payload.field]: action.payload.value,
          },
        }
      case COMPANY_FILTER_CHANGE:
      case INCIDENT_RESPONSE_REQUEST_ASYNC.INITIATE:
      case SUBMIT_INCIDENT_RESPONSE_ASYNC.INITIATE:
        return { ...state, loader: true }
      case INCIDENT_RESPONSE_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
          error: null,
        }
      case FETCH_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data?.incidentResponse,
          loader: false,
          error: null,
        }
      case INCIDENT_RESPONSE_REQUEST_ASYNC.ERROR:
      case SUBMIT_INCIDENT_RESPONSE_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case INCIDENT_RESPONSE_REQUEST_ASYNC.CANCEL:
      case SUBMIT_INCIDENT_RESPONSE_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
